'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    WaterEnvironmentWidgetController.$inject = ['$q', '$translate', 'iotService', 'measurementsService'];
    angular.module('app.iot').component('waterEnvironmentWidget', {
        template: '<div class="panel dashboard-panel {{$ctrl.cssClass}}" translate-namespace="iot"><div class="panel-heading"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h2 translate>.Water environment monitoring</h2></div></div></div><div class="panel-heading" style="padding-top: 0; padding-bottom: 0;"><div class="row"><div class="col-xs-7 col-sm-7 col-md-7 col-lg-7"><h3 translate>.water conditions</h3></div><div class="col-xs-5 col-sm-5 col-md-5 col-lg-5"><div class="panel-heading-controls"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span><select class="form-control input-sm" ng-model="$ctrl.waterFoi" ng-options="o[$ctrl.translations[\'foi.name\']] for o in $ctrl.waterFoiOptions" ng-change="$ctrl.onWaterFoiChange()"></select></div></div></div></div></div><div class="panel-body"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><span style="font-size:4em;">{{$ctrl.latestWater[\'water-temperature\'] | number : 0}}{{$ctrl.panels[\'water-temperature\'].unit}}</span></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><ul class="list-unstyled"><li>{{$ctrl.panels[\'water-level\'][$ctrl.translations[\'modality.name\']]}}: <span ng-if="$ctrl.latestWater[\'water-level\']">{{$ctrl.latestWater[\'water-level\'] | number : 1}} {{$ctrl.panels[\'water-level\'].unit}}</span><span ng-if="!$ctrl.latestWater[\'water-level\']">-</span></li><li>{{$ctrl.panels[\'water-conductivity\'][$ctrl.translations[\'modality.name\']]}}: <span ng-if="$ctrl.latestWater[\'water-conductivity\']">{{$ctrl.latestWater[\'water-conductivity\'] | number : 1}} {{$ctrl.panels[\'water-conductivity\'].unit}}</span><span ng-if="!$ctrl.latestWater[\'water-conductivity\']">-</span></li><li>{{$ctrl.panels[\'water-ph\'][$ctrl.translations[\'modality.name\']]}}:<span ng-if="$ctrl.latestWater[\'water-ph\']">{{$ctrl.latestWater[\'water-ph\'] | number : 1}} {{$ctrl.panels[\'water-ph\'].unit}}</span><span ng-if="!$ctrl.latestWater[\'water-ph\']">-</span></li></ul><div class="btn-group btn-group-sm" role="group" aria-label ng-init="modality_name_attr = (\'modality.name\' | translate)"><button type="button" class="btn btn-red" ng-repeat="panel in $ctrl.panels" ng-model="$ctrl.activePanel" uib-btn-radio="panel" ng-click="$ctrl.onChartChange()">{{panel[modality_name_attr]}}</button></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><nvd3 class="nvd3-chart" config="$ctrl.uiConfig.lineChart.config" options="$ctrl.uiConfig.lineChart.options" data="$ctrl.waterCharts[$ctrl.activePanel.slug]"></nvd3></div></div></div><div class="panel-footer"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="text-right"><a ui-sref="historical-data({category: 2, categories: { 2: {fois: [$ctrl.waterFoi.id], modality: $ctrl.activePanel.id, from: {value: -24, unit: \'hours\'}, granularity: \'hours\'}}})"><span translate>.see more</span></a></div></div></div></div></div>',
        controller: WaterEnvironmentWidgetController,
        controllerAs: '$ctrl',
        bindings: {
            cssClass: '@',
            lineColor: '@'
        }
    });

    function WaterEnvironmentWidgetController($q, $translate, iotService, measurementsService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            $ctrl.uiConfig = getUiConfig();

            $q.all({
                modalityOptions: iotService.getModalities(),
                foiOptions: iotService.getInfrastructure(),
                granularityOptions: measurementsService.getGranularities(),
                waterFoiOptions: iotService.getFoisOnline('water'),
                // waterIonsFoiOptions: iotService.getFoisOnline('water_ions'),
                translations: getTranslations()
            }).then(function (r) {

                $ctrl.translations = r.translations;
                $ctrl.granularity = _.find(r.granularityOptions, { id: '3hours' });
                $ctrl.modalityOptions = r.modalityOptions;

                $ctrl.panels = {
                    'water-temperature': _.find(r.modalityOptions, { slug: 'water-temperature' }),
                    'water-level': _.find(r.modalityOptions, { slug: 'water-level' }),
                    'water-conductivity': _.find(r.modalityOptions, { slug: 'water-conductivity' }),
                    'water-ph': _.find(r.modalityOptions, { slug: 'water-ph' })
                };

                $ctrl.activePanel = $ctrl.panels['water-temperature'];
                $ctrl.waterCharts = {};
                $ctrl.ionsCharts = {};

                $ctrl.ions = {
                    'water-nitrate': _.find(r.modalityOptions, { slug: 'water-nitrate' }),
                    'water-ammonium': _.find(r.modalityOptions, { slug: 'water-ammonium' }),
                    'water-calcium': _.find(r.modalityOptions, { slug: 'water-calcium' }),
                    'water-chloride': _.find(r.modalityOptions, { slug: 'water-chloride' })
                };

                setTranslations($ctrl.translations);

                $ctrl.waterFoiOptions = r.waterFoiOptions;
                $ctrl.waterFoi = $ctrl.waterFoiOptions[0];
                $ctrl.onWaterFoiChange();

                // $ctrl.waterIonsFoiOptions = r.waterIonsFoiOptions;
                // $ctrl.waterIonsFoi        = $ctrl.waterIonsFoiOptions[0];
                // $ctrl.onWaterIonsFoiChange();
            });
        };

        $ctrl.onChartChange = function () {
            var chart = $ctrl.waterCharts[$ctrl.activePanel.slug];

            var min = _.get(chart, '0.min.avg', undefined),
                max = _.get(chart, '0.max.avg', undefined);

            $ctrl.uiConfig.lineChart.options.chart.forceY = [];

            if (min) {
                $ctrl.uiConfig.lineChart.options.chart.forceY.push(min - min * 0.1);
            }
            if (max) {
                $ctrl.uiConfig.lineChart.options.chart.forceY.push(max + max * 0.1);
            }
        };

        /**
         * 
         */
        $ctrl.onWaterFoiChange = function () {

            measurementsService.getLatestWaterFoiMeasurements([$ctrl.waterFoi]).then(function (r) {
                $ctrl.latestWater = r[$ctrl.waterFoi.id];
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });

            var from = moment().startOf('hour').subtract(24, 'hours'),
                to = moment().endOf('hour');
            var promises = _.map($ctrl.panels, function (panel) {
                return measurementsService.getAggregated(panel, [$ctrl.waterFoi], from, to, $ctrl.granularity);
            });

            $q.all(promises).then(function (r) {
                r.forEach(function (o) {
                    $ctrl.waterCharts[o.modality.slug] = [{
                        key: [$ctrl.waterFoi[$ctrl.translations['foi.name']], o.modality[$ctrl.translations['modality.name']]],
                        color: $ctrl.lineColor ? $ctrl.lineColor : '#fff',
                        values: o.measurements || [],
                        min: _.minBy(o.measurements, 'avg'),
                        max: _.maxBy(o.measurements, 'avg')
                    }];
                });
                $ctrl.onChartChange();
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });
        };

        $ctrl.onWaterIonsFoiChange = function () {

            measurementsService.getLatestWaterFoiMeasurements([$ctrl.waterIonsFoi]).then(function (r) {
                $ctrl.latestIons = r[$ctrl.waterIonsFoi.id];
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });

            var from = moment().startOf('hour').subtract(24, 'hours'),
                to = moment().endOf('hour');
            var promises = _.map($ctrl.ions, function (ion) {
                return measurementsService.getAggregated(ion, [$ctrl.waterIonsFoi], from, to, $ctrl.granularity);
            });

            $q.all(promises).then(function (r) {
                r.forEach(function (o) {
                    $ctrl.ionsCharts[o.modality.slug] = o.measurements || [];
                });
            }).catch(function (error) {
                console.error('Oops! Something went wrong', error);
            });
        };

        /**
         * 
         */
        function getTranslations() {
            return $translate(['foi.name', 'modality.name']);
        }

        function setTranslations(i18n) {}

        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};

        /**
         * 
         */
        function getUiConfig() {
            return {
                lineChart: {
                    config: {
                        deepWatchOptions: true,
                        deepWatchData: true,
                        deepWatchDataDepth: 1,
                        debounce: 100
                    },
                    options: {
                        title: { enable: false },
                        subtitle: { enable: false },

                        chart: {
                            type: 'lineWithFocusChart',

                            useInteractiveGuideline: true,

                            height: 170,
                            duration: 300,
                            showLegend: false,
                            focusEnable: true,

                            margin: { top: 20, right: 30, bottom: 20, left: 45 },

                            forceY: [],

                            focus: {
                                height: 0
                            },

                            interpolate: 'cardinal',

                            defined: function defined(d, i) {
                                return d.avg !== null;
                            },

                            x: function x(d) {
                                return d.at;
                            },
                            y: function y(d) {
                                return d.avg;
                            },

                            xScale: d3.time.scale(),

                            xAxis: {
                                tickFormat: d3.currentLocale.timeFormat.multi([['%H:%M', function (d) {
                                    return d.getHours();
                                }], ['%a %d', function (d) {
                                    return d.getDay() && d.getDate() != 1;
                                }], ['%a %d', function (d) {
                                    return d.getDate() != 1;
                                }], ['%a %d', function (d) {
                                    return d.getMonth();
                                }], ['%a %d', function (d) {
                                    return true;
                                }]])
                            },
                            yAxis: { tickFormat: d3.format(',.1f') },

                            interactiveLayer: {
                                tooltip: {
                                    headerFormatter: d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
                                        return true;
                                    }]]),
                                    keyFormatter: function keyFormatter(d, i) {
                                        return d[1];
                                    },
                                    valueFormatter: function valueFormatter(d, i, entry) {
                                        var output = '-';

                                        if (!isNaN(d) && d !== null) {
                                            output = d3.format(',.2f')(d) + ' ' + $ctrl.activePanel.unit;

                                            if ($ctrl.activePanel.slug === 'wind-speed') {
                                                output += '<span>' + measurementsService.toBeaufort(d, true) + ' Bf</span> <span>' + measurementsService.toCompass(entry.data.dir, $ctrl.compass, '') + '</span>';
                                            }
                                        }

                                        return output;
                                    }
                                }
                            }
                        }
                    }
                },
                sparkLineChart: {
                    config: {
                        deepWatchOptions: true,
                        deepWatchData: true,
                        deepWatchDataDepth: 1,
                        debounce: 1000,
                        refreshDataOnly: true,
                        extended: true
                    },
                    options: {
                        title: { enable: false },
                        subtitle: { enable: false },

                        chart: {
                            type: 'sparklinePlus',
                            height: 26,
                            width: 120,
                            duration: 250,

                            margin: { top: 0, right: 0, bottom: 0, left: 0 },

                            x: function x(d) {
                                return d.at;
                            },
                            y: function y(d) {
                                return d.avg || 0;
                            },

                            xScale: d3.time.scale(),

                            xTickFormat: d3.time.format('%x'),

                            showMinMaxPoints: false,
                            showCurrentPoint: false,
                            showLastValue: false,
                            alignValue: false
                        }
                    }
                }

            };
        }
    }
})();